"use client";

interface WhyAccountModalProps {
  open: boolean;
  onClose: () => void;
  isParent?: boolean;
}

export default function WhyAccountModal({
  open,
  onClose,
  isParent = false
}: WhyAccountModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 pt-6 pb-4">
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            {isParent ? "Waarom een ouderaccount?" : "Waarom een account?"}
          </h3>
          {isParent ? (
            <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
              <p>
                Met een ouderaccount kunt u het abonnement voor uw kind
                beheren. U kiest de betaalmethode, en uw kind kan direct aan de
                slag, zonder zelf iets te hoeven regelen.
              </p>
              <p className="font-semibold text-gray-800">
                Waarom alleen Google, Microsoft en Apple?
              </p>
              <p>
                Door in te loggen via Google, Microsoft of Apple hoeven wij geen
                wachtwoorden op te slaan en bent u niet afhankelijk van ons voor
                de beveiliging van uw account.
              </p>
            </div>
          ) : (
            <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
              <p>
                <span className="text-mathorange font-semibold">Wis</span>
                <span className="text-mathyellow font-semibold">Wiz</span>{" "}
                geeft persoonlijke ondersteuning en daarvoor heb je een account
                nodig.
              </p>
              <p className="font-semibold text-gray-800">
                Waarom alleen Google, Microsoft en Apple?
              </p>
              <p>
                Door in te loggen via Google, Microsoft of Apple hoeven wij geen
                wachtwoorden op te slaan en ben je niet afhankelijk van ons voor
                de beveiliging van je account.
              </p>
            </div>
          )}
        </div>
        <div className="px-6 pb-6 pt-2">
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-lg bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200 transition-colors"
          >
            Sluiten
          </button>
        </div>
      </div>
    </div>
  );
}
